module.exports = __webpack_public_path__ + "media/images/countrysquared/vu-dcd741d83a445dc9ef204c9db62c624f.svg";